// src/services/auth.js

const BASE_URL = process.env.REACT_APP_API_URL  

// ======================
// SIGNUP
// ======================
export const signupUser = async (data) => {
  try {
    const res = await fetch(`${BASE_URL}/auth/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: data.name,
        email: data.email,
        phone: data.phone,
        password: data.password,
      }),
    });

    const result = await res.json();

    return result;
  } catch (err) {
    console.error("Signup error:", err);

    return {
      success: false,
      message: "Network error",
    };
  }
};

// ======================
// LOGIN
// ======================
export const loginUser = async (data) => {
  try {
    const res = await fetch(`${BASE_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: data.email,
        password: data.password,
      }),
    });

    const result = await res.json();

    return result;
  } catch (err) {
    console.error("Login error:", err);

    return {
      success: false,
      message: "Network error",
    };
  }
};